var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"wraper"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.img_cave_logo}}),_c('router-link',{staticClass:"title",attrs:{"to":'/'}},[_vm._v("Columbia Imaging and Vision Laboratory")]),_c('div',[_c('Navigation')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }